// decryptedResources.js
'use strict';
import { fromJS } from 'immutable';
import {
  MERGE_DECRYPTED_RESOURCE_DATA,
  REMOVE_DECRYPTED_RESOURCE_DATA,
} from '../ActionTypes.js';

export const defaultState = fromJS({});

/**
 * Decrypted Resources
 * @module reducer/decryptedResources
 */
const decryptedResources = (state = defaultState, action) => {
  switch (action.type) {
    case MERGE_DECRYPTED_RESOURCE_DATA:
      return _MERGE_DECRYPTED_RESOURCE_DATA(action.payload)(state);
    case REMOVE_DECRYPTED_RESOURCE_DATA:
      return _REMOVE_DECRYPTED_RESOURCE_DATA(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Merge decrypted resources' data
 * @kind reducer/actionType
 * @name MERGE_DECRYPTED_RESOURCE_DATA
 * @param {array} {selectPath} - select path
 * @param {any} {data} - data
 * @return {Immutable.Map} New state
 */
const _MERGE_DECRYPTED_RESOURCE_DATA =
  ({ selectPath, data }) =>
  state => {
    return state.mergeDeepIn(selectPath, data);
  };

/**
 * Remove decrypted resources' data
 * @kind reducer/actionType
 * @name REMOVE_DECRYPTED_RESOURCE_DATA
 * @param {array} {selectPath} - select path
 * @return {Immutable.Map} New state
 */
const _REMOVE_DECRYPTED_RESOURCE_DATA =
  ({ selectPath }) =>
  state => {
    return state.deleteIn(selectPath);
  };

export default decryptedResources;
